import { Grid } from '@mui/material'
import React, { useEffect, useState } from 'react'
import MainCard from 'ui-component/cards/MainCard'
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { fetchStates } from 'API/AgentOnboarding/api';

const RmMappingLayout = () => {
    const [Filter, setFilter] = useState({ type: "", user_type: "", state: "", district: "" })
    const [StateList, setStateList] = useState(null)


    const handleFilterChange = (field, value) => {
        if (value !== 'select') {
            setFilter({ ...Filter, [field]: value })
        }
        else {
            setFilter({ ...Filter, [field]: "" })
        }
    }

    useEffect(() => {
        fetchStates(setStateList)
    }, [])

    console.log("states", StateList);



    return (
        <Grid container>
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                <MainCard >
                    <Grid container spacing={1}>
                        <Grid item xl={3} lg={3} md={3} sm={12} xs={12}>
                            <Box sx={{ minWidth: 120 }}>
                                <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">Type</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={Filter.type ? Filter.type : 'select'}
                                        label="Type"
                                        onChange={(e) => handleFilterChange('type', e.target.value)}
                                    >
                                        <MenuItem value={'select'}>Select</MenuItem>
                                        <MenuItem value={'user_based'}>User based</MenuItem>
                                        <MenuItem value={'location_based'}>Location based</MenuItem>
                                    </Select>
                                </FormControl>
                            </Box>
                        </Grid>
                        <Grid item xl={3} lg={3} md={3} sm={12} xs={12}>
                            <Box sx={{ minWidth: 120 }}>
                                <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">Type of user</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={Filter.user_type ? Filter.user_type : 'select'}
                                        label="Type of user"
                                        onChange={(e) => handleFilterChange('user_type', e.target.value)}
                                    >
                                        <MenuItem value={'select'}>Select</MenuItem>
                                        <MenuItem value={'distributor'}>Distributor</MenuItem>
                                        <MenuItem value={'territoary_manager'}>Territory Manager</MenuItem>
                                    </Select>
                                </FormControl>
                            </Box>
                        </Grid>
                        <Grid item xl={3} lg={3} md={3} sm={12} xs={12}>
                            <Box sx={{ minWidth: 120 }}>
                                <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">State</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={Filter.state ? Filter.state : 'select'}
                                        label="State"
                                        onChange={(e) => handleFilterChange('state', e.target.value)}
                                    >
                                        <MenuItem value={'select'}>Select</MenuItem>
                                        {
                                            StateList ?
                                                Object.keys(StateList).map((item, index) => (

                                                    <MenuItem value={item} key={index}>{item}</MenuItem>
                                                ))
                                                :
                                                null
                                        }
                                    </Select>
                                </FormControl>
                            </Box>
                        </Grid>
                        <Grid item xl={3} lg={3} md={3} sm={12} xs={12}>
                            <Box sx={{ minWidth: 120 }}>
                                <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">District</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={Filter.district ? Filter.district : 'select'}
                                        label="District"
                                        onChange={(e) => handleFilterChange('district', e.target.value)}
                                    >

                                        <MenuItem value={'select'}>Select</MenuItem>
                                        {
                                            StateList && Filter.state ?
                                                StateList[Filter["state"]].map((item, index) => (
                                                    <MenuItem value={item} key={index}>{item}</MenuItem>
                                                ))
                                                :
                                                null
                                        }

                                    </Select>
                                </FormControl>
                            </Box>
                        </Grid>
                    </Grid>
                </MainCard>
            </Grid>
        </Grid>
    )
}

export default RmMappingLayout